import { IReviewJsonData } from '../../../api/RatingsAndReviewsApiSdk';

export class Review {
    public headline: string;
    public rating: number;

    public static fromJson(data: IReviewJsonData) {
        const review = new Review();
        const {
            details: { headline },
            metrics: { rating }
        } = data;

        review.headline = headline;
        review.rating = rating;

        return review;
    }
}
